import React, { useMemo } from 'react'
import DefaultCard from 'components/card/DefaultCard'
import DataViewBoxWithRows from 'components/dataViewBox/DataViewBoxWithRows'
import DataViewBox from 'components/dataViewBox/DataViewBox'
import { useTranslation } from 'react-i18next'
import { formatNumberToNumberWithSpecifiedDecimals } from 'utils/commonUtils'
import { getFormattedTestType, getTestTypeColor } from 'utils/relationUtils'
import { HeaderDataEntry } from 'reportViewer'
import { useEvidencePageStyles } from './EvidencePage.styles'

export interface EvidenceHeaderProps {
    displayableDomainItem: HeaderDataEntry | null
    type: string
}

const EvidenceHeader: React.FC<EvidenceHeaderProps> = ({
    displayableDomainItem,
    type
}) => {
    const { t } = useTranslation('evidence')
    const styles = useEvidencePageStyles()

    const evidenceBoxData = useMemo(() => {
        if (!displayableDomainItem) {
            return [{ value: 'N/A' }]
        }

        return displayableDomainItem.item.items?.map(
            ({ name, testType, testResult }) => ({
                value: name,
                secondValue: testType
                    ? getFormattedTestType(testType)
                    : undefined,
                secondValueColor: testResult
                    ? getTestTypeColor(testResult)
                    : undefined
            })
        ) ?? []
    }, [displayableDomainItem])

    const score: number | 'N/A' =
        displayableDomainItem?.level !== null &&
        displayableDomainItem?.level !== undefined
            ? formatNumberToNumberWithSpecifiedDecimals(
                  displayableDomainItem.level,
                  2
              )
            : 'N/A'

    const isNegative = typeof score === 'number' ? score < 0 : false

    const scoreClass = isNegative
        ? 'negativeGenomateScoreBox'
        : 'positiveGenomateScoreBox'

    const rowClass = isNegative ? 'red' : 'blue'

    return (
        <DefaultCard className={styles.header}>
            <div className={styles.headerRow}>
                <DataViewBoxWithRows
                    label={t(`${type}.type`)}
                    rowClasses={rowClass}
                    items={evidenceBoxData}
                />
                <DataViewBox
                    classes={scoreClass}
                    label={t('labels.score')}
                    value={score}
                />
            </div>
        </DefaultCard>
    )
}

export default EvidenceHeader
